import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { SasDynamicFormService } from '../sas-dynamic-form.service';
import { FormSubmittedService } from '@services';

@Component({
    selector: 'sas-textarea-field-type',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, FormlyModule, TranslateModule],
    template: `
        <div class="form-group mb-3 position-relative">
            <div class="sas-field-label-row">
                <label [for]="field.id"
                    [id]="field.id + 'Label'"
                    [title]="field.props['helptext'] | translate"
                    class="form-label"
                    [textContent]="field.props.label"
                    translate="{{field.props.label}}">
                </label>
                @if (field.props.required) {
                <span> *</span>
                }
                @if (helpText.length) {
                <div [title]="helpText" class="sas-inline-block">
                    <i class="bi bi-info-circle-fill sas-info-icon" aria-hidden="true"></i>
                </div>
                }
                @if (field.props.maxLength && !field.props.readonly) {
                <span class="characters-left">(Characters left: {{ charactersLeft(field.props.maxLength, formControl.value) }})</span>
                }
            </div>
            <textarea [id]="field.id"
                      [name]="field.name"
                      class="form-control"
                      [ngClass]="{'is-invalid' : field.formControl.invalid && (field.formControl.dirty || formSubmittedService.isSubmitted())}"
                      title="{{field.props.placeholder! | translate}}"
                      rows="{{field.props.rows}}"
                      maxlength="{{field.props.maxLength}}"
                      [formControl]="formControl"
                      [required]="field.props.required ?? false"
                      placeholder="{{field.props.placeholder! | translate}}"
                      [readonly]="field.props.readonly"
                      role="textbox"
                      tabindex="0"
                      [attr.aria-invalid]="field.formControl.invalid && (field.formControl.dirty || formSubmittedService.isSubmitted())"
                      [attr.aria-readonly]="field.props.readonly">
            </textarea>
            <div [id]="field.id + 'Desc'" role="alert" aria-atomic="true" class="invalid-feedback">
                <small>{{ sasDynamicFormService.getFieldErrorMessage(field) }}</small>
            </div>
        </div>
    `,
    styleUrl: './sas-textarea-field-type.component.scss'
})
export class SasTextareaFieldTypeComponent extends FieldType<FieldTypeConfig> {
    formSubmittedService = inject(FormSubmittedService);
    private translate = inject(TranslateService);
    sasDynamicFormService = inject(SasDynamicFormService);

    helpText: string = '';

    ngOnInit() {
        if (this.field.props['helptext']) {
            const helpText = this.translate.instant(this.field.props['helptext']);

            this.helpText = helpText === this.field.props['helptext'] ? '' : helpText;
        }
    }

    charactersLeft(maxLength: number, currentLength: string) {
        if (currentLength === undefined) {
            return maxLength;
        }
        return maxLength - currentLength.length;
    }
}
